// src/config/firebase.js

import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database"; // <-- ADDED
import { getStorage } from "firebase/storage"; // <-- 1. IMPORT STORAGE
import { getFunctions } from "firebase/functions"; // <-- 1. IMPORT


// Your web app's Firebase configuration
const firebaseConfig = {
  // PASTE YOUR FIREBASE CONFIG OBJECT HERE
  apiKey: "AIzaSyB445VcK-8PBpW6sHCt47R36QMJnOOf6lw",
  authDomain: "zinlanka.firebaseapp.com",
  projectId: "zinlanka",
  storageBucket: "zinlanka.firebasestorage.app",
  messagingSenderId: "145274734230",
  appId: "1:145274734230:web:b62e68cf337a094ca964b7"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const rtdb = getDatabase(app); // <-- ADDED
export const storage = getStorage(app); // <-- 2. INITIALIZE AND EXPORT
export const functions = getFunctions(app, 'us-central1');
export const googleProvider = new GoogleAuthProvider();